import * as React from 'react';
import { clsx } from 'clsx';
import { UiKitThemeContext } from '../internal/context';
import { jsx as _jsx } from "react/jsx-runtime";
export const Theme = _ref => {
  let {
    theme,
    children
  } = _ref;
  const value = React.useMemo(() => ({
    theme: theme
  }), [theme]);
  if (!theme) {
    return /*#__PURE__*/_jsx("div", {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(UiKitThemeContext.Provider, {
    value: value,
    children: /*#__PURE__*/_jsx("div", {
      className: clsx({
        'design-theme--dark': theme === 'dark',
        'design-theme--colored': theme === 'colored',
        'design-theme--onOverlay': theme === 'onOverlay'
      }),
      children: children
    })
  });
};